<template>
  <div class="player px-4">
    <div class="display-flex align-center justify-space-between pt-5 pb-4">
      <img
        @click="$router.push({ name: 'DiscoverMobile' })"
        src="../../assets/mobile/icon/dot.svg"
        width="27"
      />
      <img :src="require('@/assets/ys_logo_primary-black.svg')" width="100" />
      <img
        @click="$router.push({ name: 'DiscoverMobile' })"
        src="../../assets/mobile/icon/arrow-down-white.svg"
        width="27"
      />
    </div>

    <div class="display-flex align-center justify-center my-4">
      <img src="../../assets/mobile/player.png" width="329" height="326" />
    </div>

    <div class="display-flex justify-space-between align-start">
      <div>
        <div class="mb-1 text-poppins-18 text-white">The Origin</div>
        <div class="text-dmsans-14 font-weight-500 text-white">SALVA</div>
      </div>
      <div class="display-flex align-center gap-20">
        <img src="../../assets/mobile/icon/repeat.svg" width="20" />
        <img src="../../assets/mobile/icon/heart.svg" width="20" />
      </div>
    </div>

    <div class="mt-3">
      <div class="progress-bar">
        <span class="progress-line"></span>
        <input
          type="range"
          min="0"
          max="100"
          value="0"
          class="progress"
          id="progress"
        />
      </div>
      <div class="duration mt-2 display-flex justify-space-between">
        <span>00:00</span>
        <span>-3:24</span>
      </div>
    </div>

    <div class="display-flex justify-center align-center gap-42 my-5">
      <img src="../../assets/mobile/icon/previous.svg" width="26" />
      <img src="../../assets/mobile/icon/play-white.svg" width="55" />
      <img src="../../assets/mobile/icon/next.svg" width="26" />
    </div>

    <div class="track-list mb-2">
      <div class="text-Poppins-15 font-weight-600 text-white mb-2">
        Tracklist
      </div>

      <div
        v-for="(item, index) in playList"
        :key="index"
        class="display-flex align-center gap-15 my-2 track-list__item"
        :class="{ 'is-play': item.isPlay }"
      >
        <div>
          <img
            src="../../assets/mobile/icon/playing.svg"
            width="16"
            v-if="item.isPlay"
          />
          <span v-else class="track-list__item--number"> {{ index + 1 }}</span>
        </div>
        <div>
          <div class="text-poppins-16 font-weight-500 text-white">
            {{ item.title }}
          </div>
          <div class="text-poppins-14 font-weight-500 text-grey-5">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>

    <div class="mb-2 relative">
      <img src="../../assets/mobile/you.png" class="max-full-width username" />
      <div
        class="display-flex justify-space-between align-center pa-3 absolute w-100 top-0"
      >
        <div>
          <div class="mb-1 text-poppins-18 text-white">SALVA</div>
          <div class="text-dmsans-14 font-weight-500 text-white">Artist</div>
        </div>
        <div
          class="text-poppins-12 text-black btn-follow font-weight-500 display-flex justify-center align-center"
        >
          Follow
        </div>
      </div>
    </div>

    <div class="track-list mb-2">
      <div class="text-Poppins-15 font-weight-600 text-white mb-2">Credits</div>
      <div
        v-for="i in 2"
        :key="i"
        class="display-flex align-center justify-space-between gap-15 my-3"
      >
        <div class="display-flex align-center gap-15">
          <img
            src="../../assets/mobile/notification_2.png"
            :width="40"
            :height="40"
            class="rounded"
          />
          <div>
            <div class="text-poppins-16 font-weight-500 text-white">Teeko</div>
            <div class="text-poppins-14 font-weight-500 text-white">
              producer
            </div>
          </div>
        </div>
        <div
          class="text-poppins-12 text-black btn-follow font-weight-500 display-flex justify-center align-center"
        >
          FOLLOW
        </div>
      </div>
    </div>

    <div class="track-list mb-5">
      <div class="text-Poppins-15 font-weight-600 text-white mb-2">
        283 comments
      </div>
      <div
        v-for="i in 2"
        :key="i"
        class="display-flex align-center gap-15 my-3"
      >
        <img
          src="../../assets/mobile/notification_2.png"
          :width="40"
          :height="40"
          class="rounded"
        />
        <div>
          <div class="text-poppins-16 font-weight-500 text-white">
            Tame Impala
          </div>
          <div class="text-poppins-14 text-white">this is amazing!</div>
        </div>
      </div>

      <input
        placeholder="Add your reply"
        class="text-poppins-14 text-black mt-5 reply-input"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      playList: [
        { title: "The Origin", name: "SALVA", isPlay: true },
        { title: "What is love?", name: "SALVA, Teeko", isPlay: false },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.top-0 {
  top: 0px;
}
.player {
  background: linear-gradient(180deg, #828282 0%, #000000bd 50%);
  min-height: 100vh;
}

.track-list {
  border-radius: 10px;
  background: #1a1a1a;
  padding: 20px;
  &__item {
    padding: 8px 16px;
    &--number {
      color: rgba(255, 255, 255, 0.6);
      font-size: 15px;
      font-weight: 600;
      letter-spacing: -0.3px;
    }
  }
}

.is-play {
  border-radius: 6px;
  background: #434343;
}
.progress-bar .progress-line {
  display: block;
  width: 0;
  height: inherit;
  background-color: #fff;
}

.progress-bar .progress {
  width: 100%;
  height: inherit;
  background: transparent;
  outline: none;
  position: absolute;
  top: 0;
  left: 0;
}

.progress-bar .progress::-webkit-slider-thumb {
  background: rgba(255, 255, 255, 0.23);
  border-radius: 50%;
  cursor: pointer;
}

.progress-bar {
  height: 4px;
  width: 100%;
  position: relative;
  border-radius: 60px;
  background: rgba(255, 255, 255, 0.23);
}

.progress::before {
  content: "";
  position: absolute;
  border-radius: 50%;
  top: 50%;
  right: -5px;
  z-index: 2;
  transform: translateY(-50%);
  background: inherit;
  transition: all 0.1s ease;
}
.duration span {
  color: rgba(255, 255, 255, 0.6);
  font-family: "DM Sans";
  font-size: 10px;
  font-weight: 500;
}

.btn-follow {
  border-radius: 53px;
  background: #fff;
  width: 69px;
  height: 30.837px;
}

.username {
  border-radius: 10px;
  overflow: hidden;
}

.reply-input {
  padding: 10px 16px;
  border-radius: 77.5px;
  background: #fff !important;
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// player.vue?b184c69e